import React from "react";
import CommonInputContainer from "./CommonInputContainer";

function CommonFreeTextInput({
  value,
  placeholder,
  onChange,
  label,
  error,
  onFocus,
  onBlur,
  className,
  forceError,
}) {
  return (
    <CommonInputContainer
      label={label}
      error={forceError ? error : error && !value}
      className={className}
    >
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        className={`w-full h-12 items-center px-4 border ${
          (forceError ? error : error && !value)
            ? "border-red-600"
            : "border-[#DBDBDB]"
        } rounded-lg placeholder:text-[#A4B1C1] focus:outline-none`}
      />
    </CommonInputContainer>
  );
}

export default CommonFreeTextInput;
